import { Edit2, MoreVertical, Trash2 } from "lucide-react";
import { useState } from "react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Button } from "@/components/ui/button";
import { useThemeConfig } from "@/components/ui/theme-config-provider";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";

interface ProductTileMenuProps {
  onEdit?: () => void;
  onDelete?: () => void;
}

const ProductTileMenu = ({ onEdit, onDelete }: ProductTileMenuProps) => {
  const { theme } = useThemeConfig();
  const [showConfirm, setShowConfirm] = useState(false);

  return (
    <>
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button
            aria-label="Apri menu azioni"
            variant="ghost"
            size="icon"
            className="h-6 w-6"
            onClick={(e) => e.stopPropagation()}
            onPointerDown={(e) => e.stopPropagation()}
            onPointerUp={(e) => e.stopPropagation()}
            style={{ color: theme.sectionTitleColor }}
          >
            <MoreVertical className="h-4 w-4" aria-hidden="true" />
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end">
          {onEdit && (
            <DropdownMenuItem
              onClick={(e) => {
                e.stopPropagation();
                onEdit();
              }}
            >
              <Edit2 className="h-4 w-4 mr-2" />
              <span>Modifica</span>
            </DropdownMenuItem>
          )}
          {onDelete && (
            <DropdownMenuItem
              onClick={(e) => {
                e.stopPropagation();
                setShowConfirm(true);
              }}
              style={{ color: theme.errorColor }}
            >
              <Trash2 className="h-4 w-4 mr-2" />
              <span>Elimina</span>
            </DropdownMenuItem>
          )}
        </DropdownMenuContent>
      </DropdownMenu>

      {showConfirm && onDelete && (
        <AlertDialog open={showConfirm} onOpenChange={setShowConfirm}>
          <AlertDialogContent
            style={{ backgroundColor: theme.backgroundColor }}
            onClick={(e) => e.stopPropagation()}
            onPointerDown={(e) => e.stopPropagation()}
            onPointerUp={(e) => e.stopPropagation()}
          >
            <AlertDialogHeader>
              <AlertDialogTitle>Confermi l'eliminazione?</AlertDialogTitle>
              <AlertDialogDescription style={{ color: theme.sectionTitleColor }}>
                Questa azione è irreversibile. L’elemento sarà rimosso definitivamente.
              </AlertDialogDescription>
            </AlertDialogHeader>
            <AlertDialogFooter>
              <AlertDialogCancel onClick={(e) => e.stopPropagation()}>
                Annulla
              </AlertDialogCancel>
              <AlertDialogAction
                type="button"
                variant="destructive"
                onClick={(e) => {
                  e.stopPropagation();
                  try {
                    onDelete();
                  } finally {
                    setShowConfirm(false);
                  }
                }}
              >
                Elimina dalla lista
              </AlertDialogAction>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialog>
      )}
    </>
  );
};

export default ProductTileMenu;
